import type { FunctionComponent } from 'react';
import SubnavDropdownItem, { type DropdownItemProps } from './SubnavDropdownItem';
import PaidFeatureGate from '../Gates/PaidFeatureGate';
import type { FossaFeature } from '../../settings/billing/features/consts';

type Props = DropdownItemProps & {
  isRestricted: boolean;
  modalFocusFeature?: FossaFeature;
};

export type SubnavDropdownPaidFeatureItemComponent = FunctionComponent<Props>;

/**
 * This is a Dropdown item which displays the "paid" feature badge
 */
const SubnavDropdownPaidFeatureItem: SubnavDropdownPaidFeatureItemComponent = ({
  to,
  navKey,
  children,
  isRestricted,
  modalFocusFeature,
}) => {
  return (
    <PaidFeatureGate
      isRestricted={isRestricted}
      modalFocusFeature={modalFocusFeature}
    >
      <SubnavDropdownItem
        to={to}
        navKey={navKey}
      >
        {children}
      </SubnavDropdownItem>
    </PaidFeatureGate>
  );
};

export default SubnavDropdownPaidFeatureItem;
